import { gql } from '@apollo/client/core';

export default gql`
  query TmChartViewExportPdf($charts: ChartsInput!) {
    getGraphsPDF(charts: $charts)
  }
`;
